<template>
  <div class="col-md-12 " style="overflow-x: hidden;">
    <barra-navegacao :visiblebar="true" :visiblebutton="step > 1" />
      <!-- HEADER / NAVEGAÇÃO (apenas nos passos de seleção) -->
      <b-row v-if="step < 4" class="mt-3 mb-3">
        <b-col>
          <div class="text-muted" v-if="step > 1" style="text-align: center; margin-bottom: 15px;">
            <strong>Bloco: </strong> {{ blocoSelecionadoNome }}
            <span v-if="step > 2"> | <strong>Andar: </strong> {{ andarSelecionadoNome }}</span>
          </div>
        </b-col>
      </b-row>

      <!-- PASSO 1: SELECIONAR BLOCO -->
      <div v-if="step === 1">
        <b-row>
          <b-col cols="12" v-for="(bloco, index) in blocos" :key="index">
            <b-card
              @click="selecionarBloco(bloco)"
              class="modern-nav-card"
            >
              <div><strong>{{ bloco.descricao }}</strong></div>
            </b-card>
          </b-col>
        </b-row>
        <div v-if="blocos.length === 0" class="text-center text-muted">
          <b-spinner v-if="loading" small></b-spinner>
          <span v-else>Nenhum bloco disponível.</span>
        </div>
      </div>

      <!-- PASSO 2: SELECIONAR ANDAR -->
      <div v-if="step === 2">
        <b-row>
          <b-col cols="12" v-for="(andar, index) in andares" :key="index">
            <b-card
              @click="confirmarTipoChecklist(andar)"
              class="modern-nav-card"
            >
              <div><strong>{{ andar.descricao }}</strong></div>
            </b-card>
          </b-col>
        </b-row>
        <div v-if="andares.length === 0" class="text-center text-muted">
          <b-spinner v-if="loading" small></b-spinner>
          <span v-else>Nenhum andar encontrado para este bloco.</span>
        </div>
      </div>

      <!-- PASSO 3: SELECIONAR CORREDOR -->
      <div v-if="step === 3">
        <b-row>
          <b-col cols="12" v-for="(corredor, index) in corredores" :key="index">
            <b-card
              @click="selecionarCorredor(corredor)"
              class="modern-nav-card"
            >
              <div><strong>{{ corredor.corredor ? corredor.corredor.descricao : corredor.descricao }}</strong></div>
            </b-card>
          </b-col>
        </b-row>
        <div v-if="corredores.length === 0" class="text-center text-muted">
          <b-spinner v-if="loading" small></b-spinner>
          <span v-else>Nenhum corredor encontrado para este andar.</span>
        </div>
      </div>

      <!-- PASSO 4: SELECIONAR SALA -->
      <div v-if="step === 4">
        <b-row>
          <b-col cols="12" v-for="(sala, index) in salas" :key="index">
            <b-card
              @click="criarChecklistSala(sala)"
              class="modern-nav-card"
            >
              <div><strong>{{ sala.descricaoCompleta }}</strong></div>
            </b-card>
          </b-col>
        </b-row>
        <div v-if="salas.length === 0" class="text-center text-muted">
          <b-spinner v-if="loading" small></b-spinner>
          <span v-else>Nenhuma sala encontrada para este corredor.</span>
        </div>
      </div>

      <!-- PASSO 5: PREENCHIMENTO DO CHECKLIST (TELA INTEIRA) -->
      <div v-if="step === 5 && checklistSelecionado">
        <!-- <h4 class="mb-3 text-center text-muted">Detalhes do {{ nomeModulo }}</h4> -->
        <b-card bg-variant="light" style="box-shadow: 2px 2px 5px rgba(0,0,0,0.1);">
          <b-row class="mb-3">
            <b-col cols="12" md="3" class="mb-2 mb-md-0"><strong>ID do {{ nomeModulo }}:</strong> {{ checklistSelecionado.idCheckList }}</b-col>
            <b-col cols="12" md="3" class="mb-2 mb-md-0"><strong>Período:</strong> {{ checklistSelecionado.periodoLetivo || '-' }}</b-col>
            <b-col cols="12" md="3" class="mb-2 mb-md-0"><strong>Status:</strong> <b-badge :variant="getBadgeVariant(checklistSelecionado.status)">{{ mapStatus(checklistSelecionado.status) }}</b-badge></b-col>
            <b-col cols="12" md="3" class="mb-2 mb-md-0"><strong>Autorizado:</strong> <b-badge :variant="checklistSelecionado.autorizado === null ? 'secondary' : (checklistSelecionado.autorizado ? 'success' : 'danger')">{{ checklistSelecionado.autorizado === null ? 'Aguardando' : (checklistSelecionado.autorizado ? 'Sim' : 'Não') }}</b-badge></b-col>
          </b-row>
          <b-row class="mb-3">
              <b-col cols="12">
                  <strong>Tipo de Registro:</strong> 
                  <toggle-button 
                    v-if="ehAdminOuSupervisor && (checklistSelecionado.status === 'Pen' || checklistSelecionado.status === 'Ini')"
                    :value="checklistSelecionado.ancora" 
                    @change="atualizarAncora(checklistSelecionado, $event)" 
                    :sync="true" 
                    :labels="{checked: 'Inventário', unchecked: 'Checklist'}"
                    :color="{checked: '#303f9f', unchecked: '#17a2b8'}"
                    :width="100"
                    class="ml-2"
                />
                <b-badge v-else class="ml-2" :variant="checklistSelecionado.ancora ? 'primary' : 'info'">{{ checklistSelecionado.ancora ? 'Inventário' : 'Checklist' }}</b-badge>
            </b-col>
          </b-row>
          <b-row class="mb-3">
              <b-col cols="12"><strong>Local:</strong> {{ formatarLocal(checklistSelecionado) }}</b-col>
          </b-row>
          <hr>
          <h5 class="mb-3">Itens Verificados</h5>
          
          <b-table v-if="checklistSelecionado.itens && checklistSelecionado.itens.length > 0" striped small :items="checklistSelecionado.itens" :fields="fieldsItens" responsive="sm" stacked="md">
              <template v-slot:cell(nome)="data">
                  {{ data.item.item.nome }}
              </template>
              <template v-slot:cell(quantidade)="data">
                  <b-form-input v-if="checklistSelecionado.status === 'Ini'" type="number" v-model="data.item.quantidade" size="sm" @change="atualizarQuantidade(data.item)" min="0"></b-form-input>
                  <span v-else>{{ data.item.quantidade }}</span>
              </template>
              <template v-slot:cell(observacao)="data">
                  <b-form-textarea v-if="checklistSelecionado.status === 'Ini'" v-model="data.item.observacao" size="sm" rows="1" @change="atualizarObservacao(data.item)"></b-form-textarea>
                  <span v-else>{{ data.item.observacao || '-' }}</span>
              </template>
              <template v-slot:cell(problema)="data">
                  <toggle-button 
                      v-if="checklistSelecionado.status === 'Ini'"
                      :value="data.item.problema" 
                      @change="atualizarProblema(data.item, $event)" 
                      :sync="true" 
                      :labels="{checked: 'Sim', unchecked: 'Não'}"
                      :color="{checked: '#dc3545', unchecked: '#28a745'}"
                      :width="70"
                  />
                  <b-badge v-else :variant="data.item.problema ? 'danger' : 'success'">{{ data.item.problema ? 'Sim' : 'Não' }}</b-badge>
              </template>
              <template v-slot:cell(anexos)="data">
                  <check-list-anexos
                    :id-check-list-item="data.item.idCheckListItem"
                    :nome-item="data.item.item ? data.item.item.nome : ''"
                    :anexos="data.item.anexos || []"
                    :habilitado="Boolean(data.item.problema)"
                    :permite-envio="Boolean(data.item.problema) && checklistSelecionado.status === 'Ini'"
                    :permite-exclusao="checklistSelecionado.status !== 'Fin'"
                    @anexos-adicionados="adicionarAnexos(data.item.idCheckListItem, $event)"
                    @anexo-excluido="removerAnexo(data.item.idCheckListItem, $event)"
                  />
              </template>
          </b-table>
          <div v-else class="text-center text-muted mb-4 mt-4">Nenhum item registrado neste {{ nomeModulo.toLowerCase() }}.</div>

          <!-- BOTÕES DE AÇÃO -->
          <div class="mt-4 d-flex flex-column flex-md-row justify-content-md-end">
              <b-button v-if="checklistSelecionado.status === 'Pen' && checklistSelecionado.autorizado" variant="primary" class="mb-2 mb-md-0 mr-md-2" @click="iniciarChecklist(checklistSelecionado)">Iniciar</b-button>
              <b-button v-if="checklistSelecionado.status === 'Ini'" variant="success" class="mb-2 mb-md-0 mr-md-2" @click="finalizarChecklist(checklistSelecionado)">Finalizar</b-button>
              <b-button v-if="!checklistSelecionado.autorizado && ehAdminOuSupervisor" variant="warning" class="mb-2 mb-md-0 mr-md-2" @click="autorizarChecklist(checklistSelecionado)">Autorizar</b-button>
              <b-button v-if="false" variant="secondary" class="mb-2 mb-md-0" @click="voltarFinalizacao()">Voltar</b-button>
          </div>
        </b-card>
      </div>

  </div>
</template>

<script>
import BarraNavegacao from '../../components/BarraNavegacao.vue';
import CheckListAnexos from '../../components/CheckListAnexos.vue';
import ChecklistService from '../../services/ChecklistService';
import { PerfilService } from '@/services/PerfilService';

export default {
  components: { BarraNavegacao, CheckListAnexos },
  data() {
    return {
      loading: false,
      ehAdminOuSupervisor: false,
      
      blocos: [],
      andares: [],
      corredores: [],
      salas: [],
      
      idBlocoSelecionado: null,
      idAndarSelecionado: null,
      idCorredorSelecionado: null,
      blocoSelecionadoNome: '',
      andarSelecionadoNome: '',
      corredorSelecionadoNome: '',
      
      idSolicitacao: null,
      checklistSelecionado: null,
      
      fieldsItens: [
        { key: 'nome', label: 'Item' },
        { key: 'quantidade', label: 'Quantidade', class: 'text-center' },
        { key: 'observacao', label: 'Observação' },
        { key: 'problema', label: 'Com Problema?', class: 'text-center' },
        { key: 'anexos', label: 'Anexos', class: 'anexos-item-cell text-center' }
      ]
    }
  },
  computed: {
    step() {
      return parseInt(this.$route.query.step) || 1;
    },
    nomeModulo() {
      if (this.checklistSelecionado) {
        return this.checklistSelecionado.ancora ? 'Inventário' : 'Checklist';
      }
      return 'Checklist/Inventário';
    }
  },
  created() {
    const perfilService = new PerfilService();
    this.ehAdminOuSupervisor = perfilService.ehAdminOuSupervisor;
    if (this.$route.query.solicitacaoId) {
        this.idSolicitacao = parseInt(this.$route.query.solicitacaoId);
    }
    if (this.step > 1 && !this.idBlocoSelecionado) {
        this.$router.replace({ query: { step: 1, solicitacaoId: this.idSolicitacao } }).catch(()=>{});
    }
    this.listarBlocos();
  },
  methods: {
    adicionarAnexos(idCheckListItem, anexos) {
      const item = this.checklistSelecionado.itens.find(atual => atual.idCheckListItem === idCheckListItem);
      if (item) this.$set(item, 'anexos', (item.anexos || []).concat(anexos));
    },

    removerAnexo(idCheckListItem, idAnexo) {
      const item = this.checklistSelecionado.itens.find(atual => atual.idCheckListItem === idCheckListItem);
      if (item) this.$set(item, 'anexos', (item.anexos || []).filter(anexo => anexo.idCheckListAnexo !== idAnexo));
    },

    atualizarAncora(checklist, event) {
        const isAncora = event.value;
        ChecklistService.definirAncora(checklist.idCheckList, isAncora).then(res => {
            if (res.status === 203) {
                this.alertaMensager(res.data, "Aviso", "warning");
                checklist.ancora = !isAncora;
            } else {
                checklist.ancora = isAncora;
                
                if (res.data && res.data.itens) {
                    this.$set(checklist, 'itens', res.data.itens);
                    if (this.checklistSelecionado && this.checklistSelecionado.idCheckList === checklist.idCheckList) {
                        this.checklistSelecionado = { ...checklist };
                    }
                }
                
                this.$bvToast.toast(`${this.nomeModulo} atualizado`, { variant: 'success', solid: true, autoHideDelay: 2000 });
            }
        }).catch(() => {
            checklist.ancora = !isAncora;
            this.alertaMensager(`Erro ao definir ${this.nomeModulo.toLowerCase()} como âncora`, "Erro", "error");
        });
    },

    // --- NAVEGAÇÃO / BUSCA DE LOCAIS ---
    listarBlocos() {
      this.loading = true;
      this.$http.get("/bloco").then((res) => {
          this.blocos = res.data.filter(b => b.status === 'A');
      }).finally(() => { this.loading = false; });
    },
    
    selecionarBloco(bloco) {
      this.idBlocoSelecionado = bloco.idBloco;
      this.blocoSelecionadoNome = bloco.descricao;
      this.$router.push({ query: { step: 2 } }).catch(()=>{});
      this.loading = true;
      this.$http.get("/andar/bloco?id_bloco=" + this.idBlocoSelecionado).then((res) => {
          this.andares = res.data;
      }).finally(() => { this.loading = false; });
    },
    
    confirmarTipoChecklist(andar) {
      this.idAndarSelecionado = andar.idAndar;
      this.andarSelecionadoNome = andar.descricao;
      
      this.$bvModal.msgBoxConfirm('Deseja criar um inventário para o ANDAR INTEIRO?', {
          title: 'Tipo de Inventário',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'primary',
          okTitle: 'Andar Inteiro',
          cancelTitle: 'Escolher Corredor',
          footerClass: 'p-2 d-flex justify-content-center',
          hideHeaderClose: false,
          centered: true
      }).then(value => {
          if (value === true) {
              // Clicou em "Sim, do Andar Inteiro"
              this.criarChecklist({
                  idBloco: this.idBlocoSelecionado,
                  idAndar: this.idAndarSelecionado
              });
          } else if (value === false) {
              // Clicou em "Não, quero escolher um Corredor"
              this.$router.push({ query: { step: 3 } }).catch(()=>{});
              this.loading = true;
              this.$http.get(`/andar-corredores/bloco/${this.idBlocoSelecionado}/andar/${this.idAndarSelecionado}`)
                .then((res) => {
                  this.corredores = res.data;
              }).finally(() => { this.loading = false; });
          }
      }).catch(() => {
          this.$router.push({ query: { step: 1 } }).catch(() => {});
      });
    },

    selecionarCorredor(corredorModel) {
      this.idCorredorSelecionado = corredorModel.corredor ? corredorModel.corredor.idCorredor : corredorModel.idCorredor;
      this.corredorSelecionadoNome = corredorModel.corredor ? corredorModel.corredor.descricao : corredorModel.descricao;
      
      this.$bvModal.msgBoxConfirm('Deseja criar um inventário para o CORREDOR INTEIRO?', {
          title: 'Tipo de Inventário',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'primary',
          okTitle: 'Corredor Inteiro',
          cancelTitle: 'Escolher Sala',
          footerClass: 'p-2 d-flex justify-content-center',
          hideHeaderClose: false,
          centered: true
      }).then(value => {
          if (value === true) {
              this.criarChecklist({
                  idBloco: this.idBlocoSelecionado,
                  idAndar: this.idAndarSelecionado,
                  idCorredor: this.idCorredorSelecionado
              });
          } else if (value === false) {
              this.$router.push({ query: { step: 4 } }).catch(()=>{});
              this.loading = true;
              this.$http.get(`/corredor-salas/bloco/${this.idBlocoSelecionado}/andar/${this.idAndarSelecionado}/corredor/${this.idCorredorSelecionado}`)
                  .then((res) => {
                    this.salas = res.data;
                }).finally(() => { this.loading = false; });
          }
      });
    },
    
    criarChecklistSala(sala) {
        this.criarChecklist({
            idBloco: this.idBlocoSelecionado,
            idAndar: this.idAndarSelecionado,
            idCorredor: this.idCorredorSelecionado,
            idSala: sala.sala ? sala.sala.idSala : sala.idSala
        });
    },
    
    // --- CRIAÇÃO DO CHECKLIST ---
    criarChecklist(payload) {
        if (this.idSolicitacao) {
            payload.idSolicitacao = this.idSolicitacao;
        }
        
        if (this.$route.meta && this.$route.meta.tipo === 'INVENTARIO') {
            payload.ancora = true;
        } else if (this.$route.meta && this.$route.meta.tipo === 'CHECKLIST') {
            payload.ancora = false;
        }

        this.$loading(true);
        ChecklistService.criar(payload).then(res => {
            if (res.status === 203) {
                // Erro de regra de negócio, ex: "Inventário já existe"
                if (res.data && res.data.idCheckList) {
                    ChecklistService.buscarPorId(res.data.idCheckList).then(detalhes => {
                        this.checklistSelecionado = detalhes.data;
                        this.$router.push({ query: { step: 5 } }).catch(()=>{});
                        this.$bvToast.toast(`Continuando ${this.nomeModulo.toLowerCase()} existente...`, { variant: 'info', solid: true, autoHideDelay: 4000, title: 'Aviso' });
                    }).finally(() => { this.$loading(false); });
                } else {
                    this.recuperarChecklistExistente(payload, res.data, false);
                }
            } else if (res.data && res.data.idCheckList) {
                // Força buscar os detalhes completos (incluindo itens) caso o POST não retorne tudo
                ChecklistService.buscarPorId(res.data.idCheckList).then(detalhes => {
                    this.checklistSelecionado = detalhes.data;
                    this.$router.push({ query: { step: 5 } }).catch(()=>{});
                    this.$bvToast.toast(`${this.nomeModulo} criado com sucesso!`, { variant: 'success', solid: true, autoHideDelay: 3000, title: 'Sucesso' });
                }).finally(() => { this.$loading(false); });
            } else {
                // Sucesso (200) mas a API não retornou o idCheckList esperado no JSON
                // Como ele foi criado no banco, podemos apenas recuperá-lo!
                this.recuperarChecklistExistente(payload, "Resposta inesperada da API. Recuperando registro...", true);
            }
        }).catch(err => {
            console.error(err);
            this.alertaMensager(`Erro ao criar ${this.nomeModulo}`, "Erro", "error");
            this.$loading(false);
        });
    },

    recuperarChecklistExistente(payload, mensagemErroApi, isCriadoNovo = false) {
        ChecklistService.buscarUltimoPorLocal(payload.idBloco, payload.idAndar, payload.idSala).then(res => {
            const existente = res.data;
            
            if (existente && existente.idCheckList) {
                ChecklistService.buscarPorId(existente.idCheckList).then(detalhes => {
                    this.checklistSelecionado = detalhes.data;
                    this.$router.push({ query: { step: 5 } }).catch(()=>{});
                    
                    if (isCriadoNovo) {
                        this.$bvToast.toast(`${this.nomeModulo} criado com sucesso!`, { variant: 'success', solid: true, autoHideDelay: 3000, title: 'Sucesso' });
                    } else {
                        this.$bvToast.toast(`Continuando ${this.nomeModulo.toLowerCase()} existente...`, { variant: 'info', solid: true, autoHideDelay: 4000, title: 'Aviso' });
                    }
                }).finally(() => { this.$loading(false); });
            } else {
                this.$loading(false);
                this.alertaMensager(mensagemErroApi || "O registro não pôde ser criado ou não foi encontrado.", "Aviso", "warning");
            }
        }).catch(err => {
            console.error("Erro ao buscar último registro", err);
            this.$loading(false);
            this.alertaMensager(mensagemErroApi || "Erro ao processar criação.", "Aviso", "warning");
        });
    },
    
    // --- MÉTODOS REAPROVEITADOS DE ListagemChecklist.vue ---
    alertaMensager(mensagem, titulo, tipo){
        this.$fire({
            title: titulo,
            text: mensagem,
            type: tipo,
        });
    },

    atualizarQuantidade(item) {
        ChecklistService.atualizarItemQuantidade(item.idCheckListItem, item.quantidade)
            .catch(() => this.alertaMensager("Erro ao atualizar quantidade", "Erro", "error"));
    },

    atualizarObservacao(item) {
        ChecklistService.atualizarItemObservacao(item.idCheckListItem, item.observacao)
            .catch(() => this.alertaMensager("Erro ao atualizar observação", "Erro", "error"));
    },

    atualizarProblema(item, event) {
        const novoStatus = event.value;
        ChecklistService.atualizarItemProblema(item.idCheckListItem, novoStatus).then(() => {
            item.problema = novoStatus;
        }).catch(() => {
            item.problema = !novoStatus;
            this.alertaMensager("Erro ao atualizar problema", "Erro", "error");
        });
    },

    iniciarChecklist(checklist) {
        this.$loading(true);
        ChecklistService.mudarStatus(checklist.idCheckList, 'Ini').then((res) => {
            if (res.status === 203) {
                this.alertaMensager(res.data, "Erro", "error");
            } else {
                checklist.status = 'Ini';
                this.alertaMensager(`${this.nomeModulo} iniciado com sucesso!`, "Sucesso", "success");
            }
        }).catch((err) => {
            console.error(err);
            this.alertaMensager(`Erro ao iniciar ${this.nomeModulo.toLowerCase()}`, "Erro", "error");
        }).finally(() => this.$loading(false));
    },

    finalizarChecklist(checklist) {
        this.$bvModal.msgBoxConfirm(`Tem certeza que deseja finalizar este ${this.nomeModulo.toLowerCase()} (ID ${checklist.idCheckList})? Não será possível alterá-lo após isso.`, {
          title: 'Confirmar Finalização',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim, Finalizar',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
            if (value) {
                this.$loading(true);
                ChecklistService.mudarStatus(checklist.idCheckList, 'Fin').then((res) => {
                    if (res.status === 203) {
                        this.alertaMensager(res.data, "Erro", "error");
                    } else {
                        checklist.status = 'Fin';
                        this.alertaMensager(`${this.nomeModulo} finalizado com sucesso!`, "Sucesso", "success");
                    }
                }).catch((err) => {
                    console.error(err);
                    this.alertaMensager(`Erro ao finalizar ${this.nomeModulo.toLowerCase()}`, "Erro", "error");
                }).finally(() => this.$loading(false));
            }
        });
    },

    autorizarChecklist(checklist) {
        this.$loading(true);
        ChecklistService.autorizar(checklist.idCheckList).then(() => {
            checklist.autorizado = true;
            this.alertaMensager(`${this.nomeModulo} autorizado com sucesso!`, "Sucesso", "success");
        }).catch((err) => {
            console.error(err);
            this.alertaMensager(`Erro ao autorizar ${this.nomeModulo.toLowerCase()}`, "Erro", "error");
        }).finally(() => this.$loading(false));
    },

    voltarFinalizacao() {
        if (this.idSolicitacao) {
            this.$router.push({ path: '/solicitacao/gerenciar', query: { id: this.idSolicitacao } }).catch(()=>{});
        } else {
            this.$router.push('/checklist/gerenciar');
        }
    },

    mapStatus(status) {
        const statusMap = {
            'Pen': 'Pendente',
            'Can': 'Cancelado',
            'Ini': 'Iniciado',
            'Fin': 'Finalizado'
        };
        return statusMap[status] || status;
    },

    getBadgeVariant(status) {
        const variantMap = {
            'Pen': 'warning',
            'Can': 'danger',
            'Ini': 'success',
            'Fin': 'info'
        };
        return variantMap[status] || 'secondary';
    },

    formatarLocal(item) {
        if (!item) return '';
        let partes = [];
        if (item.bloco && item.bloco.descricao) partes.push(item.bloco.descricao);
        if (item.andar && item.andar.descricao) partes.push(item.andar.descricao);
        if (item.corredor && item.corredor.descricao) partes.push(item.corredor.descricao);
        if (item.sala && item.sala.descricaoCompleta) partes.push(item.sala.descricaoCompleta);
        return partes.length > 0 ? partes.join(' - ') : 'Não informado';
    }
  }
}
</script>

<style scoped>
.local-card {
  margin-bottom: 25px;
  color: black;
  box-shadow: 2px 2px 2px 2px gray;
  font-family: Verdana;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}
.local-card:hover {
  transform: translateY(-3px);
  box-shadow: 4px 6px 8px rgba(0,0,0,0.25);
  background-color: #f8f9fa;
}
</style>
